import {
  Auth,
  connectAuthEmulator,
  getAuth,
  GoogleAuthProvider,
} from "firebase/auth";

import { app } from "integrations/firebase/app";

export const auth: Auth = getAuth(app);

auth.tenantId = import.meta.env.VITE_FIREBASE_AUTH_TENANT_ID || null;

// Use auth emulator in local environment
if (import.meta.env.VITE_USE_FIREBASE_EMULATOR === "true") {
  connectAuthEmulator(
    auth,
    `http://${import.meta.env.VITE_FIREBASE_EMULATOR_HOST}:${import.meta.env.VITE_FIREBASE_EMULATOR_AUTH_PORT}`,
  );
}

// Exported for the app's sign-in UI, which does not exist yet. When you build
// the auth gate, the signed-out screen MUST render a control that calls
// signInWithPopup(auth, googleAuthProvider) — and no e2e test will fail if it
// does not, because the e2e suite signs in through the emulator bridge
// (emulator-test-auth.ts) and never exercises this provider. An auth gate
// without that control ships a screen no human can get past, and every test
// stays green.
export const googleAuthProvider = new GoogleAuthProvider();
